import { render, staticRenderFns } from "./PriorApproval.vue?vue&type=template&id=379959d4"
import script from "./PriorApproval.vue?vue&type=script&lang=js"
export * from "./PriorApproval.vue?vue&type=script&lang=js"
import style0 from "./PriorApproval.vue?vue&type=style&index=0&id=379959d4&prod&scopped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports